import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=f38ddc18"
import script from "./OrderPayment.vue?vue&type=script&lang=js"
export * from "./OrderPayment.vue?vue&type=script&lang=js"
import style0 from "./OrderPayment.vue?vue&type=style&index=0&id=f38ddc18&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports